"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListingTenure$ = exports.ListingTenure$outboundSchema = exports.ListingTenure$inboundSchema = void 0;
exports.listingTenureToJSON = listingTenureToJSON;
exports.listingTenureFromJSON = listingTenureFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const tenurevalues_js_1 = require("./tenurevalues.js");
/** @internal */
exports.ListingTenure$inboundSchema = z.object({
    tenure_type: z.nullable(tenurevalues_js_1.TenureValues$inboundSchema).optional(),
    tenure_type_predicted: z.nullable(z.boolean()).optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "tenure_type": "tenureType",
        "tenure_type_predicted": "tenureTypePredicted",
    });
});
/** @internal */
exports.ListingTenure$outboundSchema = z.object({
    tenureType: z.nullable(tenurevalues_js_1.TenureValues$outboundSchema).optional(),
    tenureTypePredicted: z.nullable(z.boolean()).optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        tenureType: "tenure_type",
        tenureTypePredicted: "tenure_type_predicted",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var ListingTenure$;
(function (ListingTenure$) {
    /** @deprecated use `ListingTenure$inboundSchema` instead. */
    ListingTenure$.inboundSchema = exports.ListingTenure$inboundSchema;
    /** @deprecated use `ListingTenure$outboundSchema` instead. */
    ListingTenure$.outboundSchema = exports.ListingTenure$outboundSchema;
})(ListingTenure$ || (exports.ListingTenure$ = ListingTenure$ = {}));
function listingTenureToJSON(listingTenure) {
    return JSON.stringify(exports.ListingTenure$outboundSchema.parse(listingTenure));
}
function listingTenureFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.ListingTenure$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'ListingTenure' from JSON`);
}
//# sourceMappingURL=listingtenure.js.map